import { OverlayRef } from "@angular/cdk/overlay";

export class StickyNotificationRef {
  constructor(private overlayRef: OverlayRef) {}

  close(): void {
    this.overlayRef.dispose();
  }
}
